module.exports = __webpack_public_path__ + "static/media/IC_ampmarking.deb2aa60.svg";